import React from 'react';
import { Container, Typography, Grid, Avatar } from '@mui/material';
import { styled } from '@mui/system';
import ewelinaImage from '../../assets/ewelina.jpg';

const TestimonialsContainer = styled(Container)({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '16px',
  justifyContent: 'center',
  padding: '24px 0',
});

const SectionTitle = styled(Typography)({
  textAlign: 'center',
  marginBottom: '40px',
});

const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(4, 0),
   backgroundColor: '#f9fafb',
  textAlign: 'left',
}));

const TestimonialItemContainer = styled(Grid)(({ theme }) => ({
  flex: '1 1 calc(33.33% - 16px)',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    flex: '1 1 100%',
  },
}));

const TestimonialContent = styled('div')(({ theme }) => ({
 height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(4),
  backgroundColor: '#FFFFFF',
  borderRadius: theme.spacing(2),
  border: '1px solid #E0E0E0',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
}));

const TestimonialText = styled('span')(({ theme }) => ({
  color: '#4F4F4F',
  marginBottom: theme.spacing(2),
  textAlign: 'justify',
}));

const TestimonialFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(1),
}));

const AvatarContainer = styled('div')({
  marginRight: '16px',
  display: 'flex',
  alignItems: 'center',
});

const TextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
});

const TestimonialAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
}));

const TestimonialName = styled('span')(({ theme }) => ({
  color: '#4F4F4F',
  fontWeight: 'bold',
  fontSize: theme.typography.pxToRem(16),
  marginBottom: theme.spacing(1),
}));

const TestimonialRole = styled('span')(({ theme }) => ({
  color: '#737373',
  fontSize: theme.typography.pxToRem(14),
}));

const Subtitle = styled('div')({
  textAlign: 'center',
});

const Testimonials = () => {
  return (
   <Root>
        <Container>
      <SectionTitle variant="h3" gutterBottom>
      Dlaczego Dieta Niemowlaka?
      </SectionTitle>
      <Subtitle>
       <Typography variant="body2" paragraph>
                 Zobacz co mówią o nas rodzice swoich pociech
        </Typography>
      </Subtitle>
      <TestimonialsContainer maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TestimonialItemContainer>
              <TestimonialContent>
                <TestimonialText>
                  "Wszystko co potrzeba do rozszerzania diety małego dziecka. Łatwo, prosto i przyjemnie."
                </TestimonialText>
                <TestimonialFooter>
                  <AvatarContainer>
                    <TestimonialAvatar
                      alt="Avatar 1"
                      src="https://res.cloudinary.com/subframe/image/upload/v1711417507/shared/fychrij7dzl8wgq2zjq9.avif"
                    />
                  </AvatarContainer>
                  <TextContainer>
                    <TestimonialName>Maja</TestimonialName>
                    <TestimonialRole>Mama Oli</TestimonialRole>
                  </TextContainer>
                </TestimonialFooter>
              </TestimonialContent>
            </TestimonialItemContainer>
          </Grid>
          <Grid item xs={12} md={4}>
            <TestimonialItemContainer>
              <TestimonialContent>
                <TestimonialText>
                  "Szkoda, że nie było takiej aplikacji wcześniej. Przy drugim dziecku korzystam z niej codziennie."
                </TestimonialText>
                <TestimonialFooter>
                  <AvatarContainer>
                    <TestimonialAvatar
                      alt="Avatar 2"
                      src="https://res.cloudinary.com/subframe/image/upload/v1711417512/shared/btvntvzhdbhpulae3kzk.jpg"
                    />
                  </AvatarContainer>
                  <TextContainer>
                    <TestimonialName>Antoni</TestimonialName>
                    <TestimonialRole>Tata Heli i Nikodema</TestimonialRole>
                  </TextContainer>
                </TestimonialFooter>
              </TestimonialContent>
            </TestimonialItemContainer>
          </Grid>
          <Grid item xs={12} md={4}>
            <TestimonialItemContainer>
              <TestimonialContent>
                <TestimonialText>
                  "Zamiast wymyślać co przyrządzić dla dziecka, Dieta Niemowlaka ma dla mnie gotowe przepisy."
                </TestimonialText>
                <TestimonialFooter>
                  <AvatarContainer>
                    <TestimonialAvatar
                      alt="Avatar 3"
                      src={ewelinaImage}
                    />
                  </AvatarContainer>
                  <TextContainer>
                    <TestimonialName>Ewelina</TestimonialName>
                    <TestimonialRole>Mama Anastazji</TestimonialRole>
                  </TextContainer>
                </TestimonialFooter>
              </TestimonialContent>
            </TestimonialItemContainer>
          </Grid>
        </Grid>
      </TestimonialsContainer>
    </Container>
    </Root>
  );
};

export default Testimonials;
